/**
 * @generated SignedSource<<00ea73c3cc89f4fbd7fc7e74bfca4788>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerTabs_sku">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_sku";
};
export type PdpRespSharedSellerDetails_sku$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabs_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "e46e80d6d6531bfe675b5a56e0ed55c7";

export default node;
